import React from 'react';

import Row from '@amzn/meridian/row';

import { ContactCard } from 'src/components/VendorDetails/ContactCard';
import { IVendorContact } from 'src/data/VendorContactsData';

import '../VendorContacts.scss';

interface ContactsCardsProps {
    contacts: IVendorContact[];
}

export const ContactsCards: React.FC<ContactsCardsProps> = ({ contacts }) => {
    return (
        <Row wrap="down" widths="grid-4" width="100%" alignmentVertical="stretch" spacing="300">
            {contacts.map((contact) => (
                <ContactCard key={contact.id} contact={contact} />
            ))}
        </Row>
    );
};
